import createSelectors from './createSelectors';
import Count from '../models/Count';

const Select = createSelectors(Count, {});

export default Select;
